import React from 'react'
import { useDispatch } from 'react-redux';
import SweetAlert from "sweetalert2";
import { LI } from '../../../../../../AbstractElements'
import { Href } from '../../../../../../Utils/Constants'
import { EditDeleteLinkProps, UserCallbackUserType, UserProps } from '../../../../../../Types/Contact.type';
import { deletedUser, setTempId } from '../../../../../../ReduxToolkit/Reducers/ContactReducer';
import { setSelectedUser } from '../../../../../../ReduxToolkit/Reducers/ChatReducer';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../ReduxToolkit/Store';

export default function EditDeleteLink({ selectedUser, userEditCallback }: EditDeleteLinkProps) {
    const { users } = useSelector((state: RootState) => state.contact);
    const dispatch = useDispatch();
    const editUsers = (usersData: UserCallbackUserType) => {
        if (usersData.id !== undefined) {
            dispatch(setTempId(usersData.id));
            userEditCallback(true, usersData as UserProps);
        }
    };
    const onDeleteUser = (userId: number | undefined) => {
            SweetAlert.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this imaginary file!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "cancel",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    dispatch(deletedUser(userId));
                  const newUsers= users.filter((user) => user.id !== userId)
                  if (newUsers.length > 0) {
                      dispatch(setSelectedUser(newUsers[0]));
                  } else {
                      dispatch(setSelectedUser(null));
                  }            
                    SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
                } else {
                    SweetAlert.fire("Your imaginary file is safe!");
                }
            });
    };
    return (
        <>
            <LI><a href={Href} onClick={() => editUsers(selectedUser)}>{'Edit'}</a></LI>
            <LI><a href={Href} onClick={() => onDeleteUser(selectedUser.id)}>{'Delete'}</a></LI>
        </>
    )
}